/* eslint-disable no-unused-vars */
// -----------------------------------------------------------------------------
export enum KnownRawGlobalConfigs {
  PassiveAnalyticsPersistentPhasing = 'passive_analytics_persistent_phasing',
  // eslint-disable-next-line max-len
  MinimumGameSessionTimeToDisplayPromotionMins = 'minimum_game_session_time_to_display_promotion_mins',
  MinimumVisibleTimeToCountInSeconds = 'min_visible_time_to_count_seconds',
  AutoDismissPromotionSecs = 'auto_dismiss_promotion_in_seconds',
  MinNumberOfAdsDisplayedBeforeShow = 'min_number_of_ads_displayed_before_show',
  CooldownFromPreviousPromoInHours = 'cooldown_from_previous_promotion_hours',
  CooldownFromPreviousPromoOfferInHours = 'cooldown_from_previous_promotion_offer_hours',
}

// -----------------------------------------------------------------------------
export interface RawGlobalConfigurations {
  [key: string]: string;
}
